import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "label"
}

import TCheckbox from "vue-tailwind/dist/t-checkbox";
import { VIconSvg } from "@/components";
import { ref, computed, watch } from "vue";

export interface Props {
  value?: string | boolean | number;
  options: Array<{
    label: string;
    code: string;
    icon?: string;
  }>;
  trackBy?: string;
  size?: string;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'VInputCheckboxMultiState',
  props: {
    value: { type: [String, Boolean, Number], default: "" },
    options: { default: () => [
    {
      label: "",
      code: "",
    },
  ] },
    trackBy: { default: "id" },
    size: { default: "md" }
  },
  emits: ["input"],
  setup(__props: any, { emit: __emit }) {

const emit = __emit;

const props = __props;

const index = ref(0);
const selectedState = ref("");

const checkboxCheckedClass = computed(() => {
  return index.value > 0 ? "multistate-checkbox-checked" : "";
});

const checkboxSize = computed(() => {
  return `size-${props.size}`;
});

const selectedStateIcon = computed(() => {
  return props.options[index.value]?.icon;
});

const selectedStateLabel = computed(() => {
  return props.options[index.value]?.label;
});

watch(
  () => props.value,
  () => {
    index.value = props.options.findIndex((item) => item[props.trackBy] === props.value);
  },
  { immediate: true }
);

const onClickChangeActiveOption = () => {
  index.value += 1;

  if (index.value >= props.options.length) {
    index.value = 0;
  }

  changeSelectedState();
};

const changeSelectedState = () => {
  const activeOption = props.options[index.value];

  selectedState.value = activeOption[props.trackBy];

  emit("input", selectedState.value);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "multistate-wrapper",
    onClick: onClickChangeActiveOption
  }, [
    _createElementVNode("div", {
      class: _normalizeClass(["multistate-checkbox", [checkboxCheckedClass.value, checkboxSize.value]])
    }, [
      (selectedStateIcon.value)
        ? (_openBlock(), _createBlock(_unref(VIconSvg), {
            key: 0,
            class: "multistate-checkbox-icon",
            name: selectedStateIcon.value.name,
            "color-tag": selectedStateIcon.value.colorTag,
            color: "fc-hover",
            size: "2xs"
          }, null, 8, ["name", "color-tag"]))
        : _createCommentVNode("", true),
      _createVNode(_unref(TCheckbox), {
        class: "checkbox",
        value: selectedState.value
      }, null, 8, ["value"])
    ], 2),
    (selectedStateLabel.value)
      ? (_openBlock(), _createElementBlock("label", _hoisted_1, _toDisplayString(selectedStateLabel.value), 1))
      : _createCommentVNode("", true)
  ]))
}
}

})